import { render, staticRenderFns } from "./BuildingRuleList.vue?vue&type=template&id=07019e50&"
import script from "./BuildingRuleList.vue?vue&type=script&lang=js&"
export * from "./BuildingRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports